import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class CartService {

  public cart = [];
  public total = 0;

  constructor(public toastCtrl: ToastController) {}

  getCart() {
    return this.cart;
  }

  addProduct(producto, cant, modificadores, nota) {
    // console.log(producto);

    this.cart.push({
      Folio: producto.cProductoFolio,
      Descripcion: producto.precio.cProductosDescripcion,
      Precio: producto.precio.cProductosPrecio,
      Descuento: producto.precio.cProductosDescuento,
      Imagen: producto.cProductoImg,
      Cant: cant,
      Modificadores: modificadores,
      Comentario: nota,
    });

    this.presentToast('Artículo agregado al carrito.', 'success', 500);
    this.updateCartTotal();
    // console.log('Carrito', this.cart);
  }

  deleteProduct(index: number) {
    this.cart.splice(index, 1);
    this.updateCartTotal();
    this.presentToast('Artículo eliminado del carrito.', 'danger', 500);
  }

  updateCartTotal() {
    this.total = 0;
    let totalM = 0;
    let precioCantidad = 0;

    this.cart.forEach((producto) => {
      precioCantidad = producto.Precio * producto.Cant;
      this.total += Number(precioCantidad - (producto.Descuento * producto.Cant));

      if (producto.Modificadores != null) {
        producto.Modificadores.forEach((modificador: any) => {
          totalM += Number(modificador.Precio * (modificador.Cant * producto.Cant));
        });
      }
    });

    this.total += totalM;
  }

  deleteCart() {
    this.cart.length = 0;
    this.total = 0;
    // this.presentToast('El carrito se vacio correctamente.', 'dark', 500);
  }

  async presentToast(message, color, duration) {
    const toast = await this.toastCtrl.create({
      mode: 'ios',
      message,
      duration,
      color,
      position: 'top'
    });
    toast.present();
  }
}
